module.exports = "/_next/static/images/NorthBouy-ca7ee5a9f42d4404f90bb97b723e6715.svg";